/**
 * Custom Cam Wrapper
 * @module components/Camera
 */
import * as THREE from 'three';
import PubSub from 'pubsub-js';

import { MOUSE_DRAG_START, MOUSE_DRAG, MOUSE_DRAG_END, MOUSE_WHEEL, KEY_MOVE } from '../events.js';

class Camera {

    constructor(props) {

        this.scene = props.scene;

        this.state = {
            currentCameraNormal: 0,
            desiredCameraNormal: 0,
            cameraDragOrigin: new THREE.Euler()
        };

        this.camera = new THREE.PerspectiveCamera(75, window.innerWidth/window.innerHeight, 0.1, 1000);
        this.cameraPitch = new THREE.Object3D(); //look up/down
        this.cameraWrap = new THREE.Object3D(); //move, look left/right

        this.cameraPitch.add(this.camera);
        this.cameraWrap.add(this.cameraPitch);
        
        PubSub.subscribe(MOUSE_WHEEL, this.handleMouseWheel);
        PubSub.subscribe(MOUSE_DRAG_START, this.handleMouseDragStart);
        PubSub.subscribe(MOUSE_DRAG, this.handleMouseDrag);
        PubSub.subscribe(MOUSE_DRAG_END, this.handleMouseDragEnd);
        PubSub.subscribe(KEY_MOVE, this.handleKeyMove);

        this.scene.add(this.cameraWrap);
    }

    setState(newState) {
        for(let key in newState) {
            this.state[key] = newState[key];
        }
    }

    setView(view) {

        this.setState({
            currentCameraNormal: view.startCameraNormal-0.1,
            desiredCameraNormal: view.startCameraNormal
        });

        //reset camera
        this.camera.quaternion.set(0, 0, 0, 1);
        this.cameraWrap.position.set(0, 0, 0);
        this.cameraWrap.quaternion.set(0, 0, 0, 1);
        this.cameraPitch.quaternion.set(0, 0, 0, 1);

        //hotfix: rotate Camera 45° for Random View 
        if(view.path === '/') {
            this.cameraWrap.rotateOnAxis(new THREE.Vector3(0, 1, 0), Math.PI/4);
        }

        this.currentView = view;
    }

    handleResize(e) {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
    }

    cancelDesiredNormal() {
        this.setState({desiredCameraNormal: this.state.currentCameraNormal})
    }

    update() {
        let currentCameraNormal = this.state.currentCameraNormal;
        let desiredCameraNormal = this.state.desiredCameraNormal;
        if(this.currentView.isFinite) {
            desiredCameraNormal = Math.min(1, desiredCameraNormal);
            desiredCameraNormal = Math.max(0, desiredCameraNormal);
        }
        
        currentCameraNormal += (desiredCameraNormal - currentCameraNormal)/100;
        this.setState({currentCameraNormal, desiredCameraNormal});
        const camPos = this.currentView.lerpCamera(currentCameraNormal, this.cameraWrap, this.camera);

        this.cameraWrap.position.copy(camPos);
    }


    /**
     * CONTROLS
     */
    handleKeyMove = (msg, data) => {
        let {desiredCameraNormal} = this.state;
        desiredCameraNormal -= data * 0.0025;
        this.setState({desiredCameraNormal});
    }

    handleMouseWheel = (msg, data) => {
        let {desiredCameraNormal} = this.state;
        desiredCameraNormal -= data;
        this.setState({desiredCameraNormal});
    }

    handleMouseDragStart = (msg, data) => {
        const cameraDragOrigin = new THREE.Euler();
        cameraDragOrigin.x = this.cameraPitch.rotation.x;
        cameraDragOrigin.y = this.cameraWrap.rotation.y;
        this.setState({cameraDragOrigin});
    }

    handleMouseDrag = (msg, dragDistance) => {
        this.cameraWrap.rotation.y  = this.state.cameraDragOrigin.y + dragDistance.x/600;
        this.cameraPitch.rotation.x = this.state.cameraDragOrigin.x + dragDistance.y/600;
        this.cameraPitch.rotation.x = Math.min(Math.PI/4, this.cameraPitch.rotation.x);
        this.cameraPitch.rotation.x = Math.max(-Math.PI/4, this.cameraPitch.rotation.x);
    }
}

export default Camera;